module.exports = __webpack_public_path__ + "fonts/Vazir-Bold.3b61b6b.ttf";